import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  "class": "position-absolute top-0 end-0 hover-element m-2"
};
var _hoisted_2 = {
  "class": "align-items-center action"
};
var _hoisted_3 = {
  key: 0,
  "class": "badge rounded-pill text-white sh-bg-red font-size-10 font-weight-regular small line-height-13 px-1 py-0"
};
var _hoisted_4 = {
  "class": "flex-shrink-0"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  "class": "flex-grow-1 ms-3"
};
var _hoisted_7 = {
  "class": "d-flex align-items-center mb-2"
};
var _hoisted_8 = {
  "class": "title font-size-12"
};
var _hoisted_9 = {
  "class": "date font-size-10 opacity-75 ms-2"
};
var _hoisted_10 = {
  "class": "description text-truncate-2 sh-color-gray-3 font-size-10"
};
import { useUserStore } from '@dashboardApp/stores/UserStore';
import { dateTimeAgo } from '@dashboardApp/helpers/date';
import { messageAvatar, messageTitleAndAvatar, viewThread } from '@dashboardApp/helpers/inbox';
import ArchiveMessageButton from './ArchiveMessageButton';
export default {
  __name: 'MessageRow',
  props: {
    message: {
      type: Object,
      "default": {}
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useUserStore = useUserStore(),
      user = _useUserStore.user;
    var _messageTitleAndAvata = messageTitleAndAvatar(props.message, user.id),
      title = _messageTitleAndAvata.title,
      avatar = _messageTitleAndAvata.avatar;
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass([{
          'unread': !__props.message.read,
          'active': __props.message._jv.id === _ctx.$route.params.id
        }, "message position-relative text-decoration-none sh-text-black py-3 px-2 pe-5"]),
        role: "button"
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _unref(viewThread)(_ctx.$router, __props.message, true);
        }),
        "class": "text-decoration-none d-inline-block me-1 hover-opacity"
      }, _cache[2] || (_cache[2] = [_createElementVNode("img", {
        src: "/img/v5/db-ic_reply.svg"
      }, null, -1)])), _createVNode(_unref(ArchiveMessageButton), {
        id: __props.message._jv.id,
        isArchived: __props.message.archived
      }, null, 8, ["id", "isArchived"])]), __props.message.unread_count ? (_openBlock(), _createElementBlock("span", _hoisted_3, "+" + _toDisplayString(__props.message.unread_count), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _unref(viewThread)(_ctx.$router, __props.message);
        }),
        "class": "d-flex align-items-start"
      }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
        src: _unref(avatar),
        "class": "icon rounded-circle",
        width: "75",
        height: "75"
      }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_unref(title)), 1), _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(dateTimeAgo)(__props.message.date)), 1)]), _createElementVNode("div", _hoisted_10, _toDisplayString(__props.message.excerpt), 1)])])], 2);
    };
  }
};